import api from 'data/api';

export const loadFR = api('GET /api/mobile/finance/financialresults/:id');

export const approveFR = api(
  'POST /api/mobile/finance/financialresults/:id/approve'
);
export const rejectFR = api(
  'POST /api/mobile/finance/financialresults/:id/reject'
);
export const moreInfoFR = api(
  'POST /api/mobile/finance/financialresults/:id/moreinfo'
);
export const undoFR = api('POST /api/mobile/finance/financialresults/:id/undo');
export const downloadInvoice = api(
  'GET /api/mobile/finance/financialresults/invoices/:id/attachment'
);
